export default "__VITE_ASSET__CKBp1bPS__"